import { BsTwitterX } from "react-icons/bs"
import { FaFacebook, FaInstagram, FaLinkedin, FaTelegram, FaTiktok, FaYoutube, FaYoutubeSquare } from "react-icons/fa"
import { FaWhatsapp } from "react-icons/fa6"

export default function ShareButtons({title, category, ig_link, tiktok_link, fb_link}){

    const url = window.location.href

    return(
        <>
        
        <div className="flex flex-col gap-4 mt-6 rounded-2xl border border-white p-8">
            <span>
                Ikut Event ini di:
            </span>
            <div className='flex gap-2'>
                <a
                  href={fb_link} target="_blank"
                >
                    <span className="flex gap-2 flex-row items-center rounded-full bg-blue-500 py-2 px-4 border border-white transform hover:scale-105 transition-all duration-300" >
                        <FaFacebook></FaFacebook>
                    </span>
                </a>
                <a
                  href={ig_link} target="_blank"
                >
                    <span className="flex gap-2 flex-row items-center rounded-full bg-black py-2 px-4 border border-white transform hover:scale-105 transition-all duration-300 cursor-pointer">
                        <FaInstagram></FaInstagram>
                    </span>
                </a>
                <a
                  href={tiktok_link} target="_blank"
                >
                    <span className="flex gap-2 flex-row items-center rounded-full bg-black py-2 px-4 border border-white transform hover:scale-105 transition-all duration-300 cursor-pointer">
                        <FaTiktok></FaTiktok>
                    </span>
                </a>
            </div>
            
        </div>
        <div className="flex flex-col gap-4 mt-6 rounded-2xl border border-white p-8">
            <span>
                Share&nbsp;
                {category === "1"
                    ? "Artikel"
                    : category === "2"
                    ? "Blog"
                    : category === "3"
                    ? "News"
                    : category === "4"
                    ? "Event"
                    : "Lainnya"
                } ini melalui media Social:
            </span>
            <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
                target="_blank"
                className="text-white"
            >
                <div className='flex'>
                    <span className="flex gap-2 flex-row items-center rounded-full bg-blue-500 py-2 px-4 border border-white transform hover:scale-105 transition-all duration-300">
                        <FaFacebook></FaFacebook> Facebook
                    </span>
                </div>
            </a>
            <a
                href={`https://twitter.com/intent/tweet?url=${url}&text=${title}`}
                target="_blank"
                className="text-white rounded"
            >
                <div className='flex'>
                    <span className="flex gap-2 flex-row items-center rounded-full bg-black py-2 px-4 border border-white transform hover:scale-105 transition-all duration-300">
                        <BsTwitterX></BsTwitterX> Twitter / X
                    </span>
                </div>
            </a>
            <a
                href={`https://wa.me/?text=${title} ${url}`}
                target="_blank"
                className="text-white rounded"
            >
                <div className='flex'>
                    <span className="flex gap-2 flex-row items-center rounded-full bg-green-500 py-2 px-4 border border-white transform hover:scale-105 transition-all duration-300">
                        <FaWhatsapp></FaWhatsapp> WhatsApp
                    </span>
                </div>
            </a>
            <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`}
            target="_blank"
            rel="noopener noreferrer"
            >
                <div className='flex'>
                    <span className="flex gap-2 flex-row items-center rounded-full bg-[#0077B5] py-2 px-4 border border-white transform hover:scale-105 transition-all duration-300">
                        <FaLinkedin></FaLinkedin> LinkedIn
                    </span>
                </div>
            </a>
        </div>
        <div className="flex flex-col gap-4 mt-6 rounded-2xl border border-white p-8">
            <span>
                Follow Media Social Kami:
            </span>
            <div className='flex gap-2'>
                <a
                  href="https://www.facebook.com/RadarPulsaOfficial" target="_blank"
                >
                    <span className="flex gap-2 flex-row items-center rounded-full bg-blue-500 py-2 px-4 border border-white transform hover:scale-105 transition-all duration-300" >
                        <FaFacebook></FaFacebook>
                    </span>
                </a>
                <a
                  href="https://www.instagram.com/radarpulsa_official/" target="_blank"
                >
                    <span className="flex gap-2 flex-row items-center rounded-full bg-black py-2 px-4 border border-white transform hover:scale-105 transition-all duration-300 cursor-pointer">
                        <FaInstagram></FaInstagram>
                    </span>
                </a>
                <a
                  href="#" target="_blank"
                >
                    <span className="flex gap-2 flex-row items-center rounded-full bg-red-500 py-2 px-4 border border-white transform hover:scale-105 transition-all duration-300 cursor-pointer">
                        <FaYoutube></FaYoutube>
                    </span>
                </a>
                <a
                  href="https://www.tiktok.com/@radarpulsa.official" target="_blank"
                >
                    <span className="flex gap-2 flex-row items-center rounded-full bg-black py-2 px-4 border border-white transform hover:scale-105 transition-all duration-300 cursor-pointer">
                        <FaTiktok></FaTiktok>
                    </span>
                </a>
                <a
                  href="https://t.me/RadarPulsa" target="_blank"
                >
                    <span className="flex gap-2 flex-row items-center rounded-full bg-[#0088cc]  py-2 px-4 border border-white transform hover:scale-105 transition-all duration-300 cursor-pointer">
                        <FaTelegram></FaTelegram>
                    </span>
                </a>
            </div>
            
        </div>
        </>
    )

}